import React from "react";
import { Link } from "react-router-dom";
import NavigationBtns from "./Navigation-btns";

const FirebaseSetup = () => {
  return (
    <div
      className="introduction "
      data-aos="fade-right"
      data-aos-delay="300"
      data-aos-duration="1000"
    >
      <h1 className="title">Firebase</h1>
      <p className="inner-text">
        We use Firebase Authentication, Cloud Messaging and Firestore in Uzmart.
        So, you have to setup Firebase in order to use Uzmart properly.
      </p>
      <h4 className="mt-4">Web firebase configuration</h4>
      <div className="mt-4" />
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/OLwNp_e5bxM"
          title="Firebase configuration"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      <div className="mt-4" />
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/jCgZZiz1480"
          title="How to run connect firebase to project"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>

      <div className="mt-4" />
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/5HzrGiY9cFo"
          title="Firebase auth configuration"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      <div className="mt-4" />
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/5HzrGiY9cFo"
          title="Firebase auth configuration"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      <div className="mt-4" />
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/cchc8T1QnCE?si=RvYlapwJ2S-oMd0h"
          title="Cloud messaging"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      <div className="">
        <p style={{ margin: "10px" }}>
          Add downloaded file to backend_folder/storage/app and run the command
          php artisan storage:link if you haven’t run it before
        </p>
        <img
          src={`../assets/img/google-service-json.jpg`}
          alt="icon"
          style={{ width: "100%" }}
        />
      </div>
      <div className="mt-4" />
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/29ARDVIXvXk"
          title="Firestore"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      <h4 className="my-4">Mobile firebase configuration</h4>
      <div className="flex flex-column gap-2">
        <div className="iframe-wrapper">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/nDlumAt_XJA?si=ukp7T4dzyksrRsvl"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
        <div className="iframe-wrapper">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/8qALn3V3ACA?si=qqW5P8l4YTbiBDDF"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <NavigationBtns />
    </div>
  );
};

export default FirebaseSetup;
